const baseAlertConfig = {
  'data-testid': 'error',
  variant: 'danger',
  className: 'a-mt-10',
  message: 'An error occurred',
};

const alertTypeConfigs = {
  default: baseAlertConfig,
  publish: {
    ...baseAlertConfig,
    message: 'An error occurred while publishing data',
    'data-testid': 'publish-error',
  },
  fetch: {
    ...baseAlertConfig,
    message: 'An error occurred while fetching data',
    'data-testid': 'fetch-error',
  },
};

export const alertTypes = Object.keys(alertTypeConfigs).reduce(
  (accumulator, item) => ({ ...accumulator, [item]: item }),
  {}
);

export const getAlertConfigsFromObj = (err) => {
  const { apiErrorMessage } = err || {};
  if (apiErrorMessage) {
    return {
      'data-testid': 'custom-error',
      variant: 'danger',
      className: 'a-mt-10',
      message: apiErrorMessage,
    };
  }
  return alertTypeConfigs.default;
};

export const getAlertConfigs = (alertType) => {
  if (typeof alertType === 'object') {
    return getAlertConfigsFromObj(alertType);
  }

  switch (alertType) {
    case 'publish': {
      return alertTypeConfigs.publish;
    }
    case 'fetch': {
      return alertTypeConfigs.fetch;
    }
    default: {
      return alertTypeConfigs.default;
    }
  }
};
